<template>
    <VNotification
        :status="status"
        :text="text"
        :type="type.success"
    >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0007 1.66675C5.40934 1.66675 1.66797 5.40812 1.66797 9.99943C1.66797 14.5907 5.40934 18.3321 10.0007 18.3321C14.592 18.3321 18.3333 14.5907 18.3333 9.99943C18.3333 5.40812 14.592 1.66675 10.0007 1.66675ZM13.9837 8.08291L9.25904 12.8075C9.14238 12.9242 8.98406 12.9909 8.81741 12.9909C8.65076 12.9909 8.49244 12.9242 8.37578 12.8075L6.01763 10.4494C5.77598 10.2077 5.77598 9.80778 6.01763 9.56613C6.25928 9.32448 6.65924 9.32448 6.90089 9.56613L8.81741 11.4826L13.1004 7.19965C13.3421 6.958 13.742 6.958 13.9837 7.19965C14.2253 7.4413 14.2253 7.83293 13.9837 8.08291Z" fill="#00BB34"/>
        </svg>
    </VNotification>
</template>

<script lang="ts">
import VNotification from "@/components/ui/notification/VNotification.vue";
import {notificationStatus} from "@/core/const";
import {defineComponent} from "vue";

export default defineComponent({
    name: "SuccessNotification",
    components: {VNotification},
    props: {
        text: {
            type: String,
            required: true
        },
        status: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            type: notificationStatus,
        }
    }
})
</script>

<style scoped>

</style>